import React from "react";
import ServicesContactCard from "./ServicesContactCard";
import ServicesHeader from "./ServicesHeader";
import ServicesCard from "./ServicesCard";

const MainServices = () => {
  return (
    <div>
      <ServicesHeader />
      <ServicesCard />
      <ServicesContactCard />
    </div>
  );
};

export default MainServices;
